import type { AllRouteEndpoints } from "../routeTypes";
export const integrationsScimScimResetTokenCacheKeys: AllRouteEndpoints[] = [];
